import TimeFormattedValue from './TimeFormattedValue';

export default TimeFormattedValue;
